export const emptyEarningsPreFilterValue: EarningsPreFilterValue = [
    -Number.MAX_SAFE_INTEGER,
    Number.MAX_SAFE_INTEGER,
];
